import { DialogModule } from '@angular/cdk/dialog';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling, withNavigationErrorHandler } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { AuthService } from '../services/auth.service';
import { initializeGoogleAnalytics } from './core/analytics/google-analytics';
import { initializeMicrosoftClarity } from './core/analytics/microsoft-clarity';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { LUCIDE_ICONS } from './core/layout/lucide-icons';
import { maybeReloadOnce, textFromUnknown } from './core/utils/chunk-reload';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
      }),
      withNavigationErrorHandler((navigationError) => {
        const combined = textFromUnknown(navigationError.error);
        if (maybeReloadOnce('router.navigation', combined, navigationError.error)) return;

        throw navigationError.error;
      }),
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(LucideAngularModule.pick(LUCIDE_ICONS), DialogModule),
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: () => () => {
        initializeGoogleAnalytics();
        initializeMicrosoftClarity();
        return Promise.resolve();
      },
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AuthService],
      useFactory: (authService: AuthService) => () => authService.bootstrapSession(),
    },
  ],
};
